import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";

import { useAuthSessionCallback } from "../auth/logto-auth-session";

const Callback = () => {
  const navigate = useNavigate();
  const completeSignIn = useCallback(
    () => void navigate({ to: "/", replace: true }),
    [navigate],
  );
  const { error, isLoading } = useAuthSessionCallback(completeSignIn);
  if (isLoading || !error) return null;
  return (
    <main className="shell shell--narrow">
      <p className="eyebrow">SECURE SIGN-IN</p>
      <h1>Sign-in failed</h1>
      <p role="alert">{error.message}</p>
    </main>
  );
};

export const Route = createFileRoute("/callback")({ component: Callback });
